// Centralised API helper
const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "mhp_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const formatDetail = (d) => {
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  return String(d);
};

// Robust body reader — protects against extensions/devtools that may have already
// consumed the response stream. Always reads from a clone, with a fallback chain.
async function readBody(res) {
  try {
    return await res.clone().text();
  } catch {
    try { return await res.text(); }
    catch { return ""; }
  }
}

export async function api(path, opts = {}) {
  const headers = { "Content-Type": "application/json" };
  if (opts.auth !== false) {
    const tok = getToken();
    if (tok) headers["Authorization"] = `Bearer ${tok}`;
  }

  let res;
  try {
    res = await fetch(`${BASE}/api${path}`, {
      method: opts.method ?? "GET",
      headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    });
  } catch (e) {
    // Network error / CORS / DNS / timeout
    throw new Error("Network error. Please check your connection and try again.");
  }

  const text = await readBody(res);
  let data = null;
  if (text) {
    try { data = JSON.parse(text); } catch { data = text; }
  }

  if (!res.ok) {
    // Prefer server-provided message; fall back to a clear status-based message.
    const msg = data ? formatDetail(data?.detail ?? data) : `Request failed (${res.status} ${res.statusText || ""})`.trim();
    throw new Error(msg);
  }
  return data;
}

export const BACKEND_URL = BASE;
